import React from 'react'
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Button from "../CustomButtons/Button.jsx";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CustomSelect from "../../components/CustomInput/CustomSelect";
import Close from "@material-ui/icons/Close";
import LoaderComponent from "../Loader.js";

import newFileModalStyle from "../../../assets/jss/user/newFolderModalStyle.jsx";
import Danger from '../Typography/Danger.jsx';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

const ProjectModal = class extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            projects: this.getProjects(this.props.projects),
            project: ''
        };

        this.handleChange = this.handleChange.bind(this);
    }
    getProjects(projects){
        const filteredProjects = projects.filter(
            (item) => item.id !== "" && item.id !== "all"
        );

        return filteredProjects;
    }
    handleChange(e) {
        this.setState({
            project: e.target.value
        });
    }
    render() {
        const { classes, saving, title, error, errorMessage, inputLabel, buttonText } = this.props;
        const { projects, project } = this.state;
        return (
            <Dialog
                classes={{
                    root: classes.modalRoot,
                    paper: classes.modal
                }}
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="newFileModal-modal-slide-title"
                aria-describedby="newFileModal-modal-slide-description"
            >
                <DialogTitle
                    id="newFileModal-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    >
                        <Button
                            simple
                            className={classes.modalCloseButton+" "+classes.modalCloseButtonCustom}
                            key="close"
                            aria-label="Close"
                            onClick={() => this.props.onClose()}
                        >
                            {" "}
                            <Close className={classes.modalClose} />
                        </Button>
                        {
                            saving ?
                                <></>
                            :
                            <h4 className={classes.modalTitle}>{title}</h4> 
                        }
                </DialogTitle>
                <DialogContent
                    id="newFileModal-modal-slide-description"
                    className={classes.modalBody}
                    >
                        {
                            error ?
                                <Danger>{errorMessage}</Danger>
                            :
                                null
                        }
                        {
                            saving ?
                                <LoaderComponent color="custom" align="center" />
                            :
                                <CustomSelect
                                    formControlProps={{
                                        fullWidth: true,
                                        className: 'custom-input m-zero'
                                    }}
                                    labelText={inputLabel}
                                    selectProps={{
                                        onChange: (e) => this.handleChange(e),
                                        value: project
                                    }}
                                    inputProps={{
                                        name: "project",
                                        id: "input-project",
                                    }}
                                    color="info"
                                    items={projects}
                                    itemLabel="name"
                                    itemValue="id"
                                />
                        }
                </DialogContent>
                {
                    saving ?
                        <></>
                    :
                        <DialogActions className={classes.modalFooter}>
                            <Button color="custom" className={classes.changeButton} disabled={(project === '')} onClick={() => this.props.onSuccess(project)}>
                                {buttonText}
                            </Button>
                        </DialogActions>
                }
            </Dialog>
        )
    }
}

ProjectModal.defaultProps = {
    open: false,
    title: "Select Project",
    buttonText: "Save",
    saving: false,
    extension: "",
    error: false,
    errorMessage: null,
    inputLabel: "Select Default Project",
}
ProjectModal.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
    buttonText: PropTypes.string,
    saving: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    inputLabel: PropTypes.string,
    projects: PropTypes.array
}
export default withStyles(newFileModalStyle)(ProjectModal);